import React from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

import itemSelectors from 'store/v2/redux/selectors/item'

class IdFinder extends React.Component {
  static displayName = 'IdFinder'

  static propTypes = {
    children: PropTypes.object,
    hideOnLoad: PropTypes.bool
  }

  shouldComponentUpdate = (nextProps) => {
    if (this.props.item && nextProps.uiKey === this.props.uiKey) {
      return false
    } else {
      return true
    }
  }

  render = () => {
    const { item, hideOnLoad } = this.props

    if (!item && hideOnLoad) {
      return null
    } else {
      return this.props.children && React.cloneElement(this.props.children, this.props)
    }
  }
}

const mapStateToProps = (state, props) => {
  const item = itemSelectors.findByIdOrSlug(state.orm.product_groups, props.id) ||
    itemSelectors.findByIdOrSlug(state.orm.bundles, props.id) ||
    itemSelectors.findByIdOrSlug(state.orm.items, props.id)

  return {
    id: item && item.id,
    item,
    uiKey: props.id
  }
}

export default reduxConnect(mapStateToProps)(IdFinder)
